import { apiClientWithMiddleware } from '../utils/API';
const hubTrialsEndpoint = '/trials/v1/hub-trials/app/name/all';
const defaultResponse = [];
export const getCurrentTrials = portalId => apiClientWithMiddleware().get(hubTrialsEndpoint, {
  query: {
    portalId
  }
}).catch(() => defaultResponse);